"use strict";
(self["webpackChunkpop_and_bottle"] = self["webpackChunkpop_and_bottle"] || []).push([[649],{

/***/ 649:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ quantityBox)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(692);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);


function quantityBox({ wrapper }) {
  const selectors = {
    increaseButton: '[data-hook="increase-quantity"]',
    decreaseButton: '[data-hook="decrease-quantity"]',
    input: '[data-hook="quantity"]',
  }

  const cache = {
    $increaseButton: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find(selectors.increaseButton),
    $decreaseButton: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find(selectors.decreaseButton),
    $input: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find(selectors.input),
  }

  ;(function init() {
    const { $increaseButton, $decreaseButton, $input } = cache

    $increaseButton.on('click', increaseItemQuantity)
    $decreaseButton.on('click', decreaseItemQuantity)
    $input.on('change', () => $input.trigger('quantity-box:change'))
  })()

  function increaseItemQuantity() {
    const { $input } = cache

    let quantity = parseInt($input.val()) + 1
    let maximumValue = $input.prop('max') || Infinity

    $input.val(Math.min(quantity, maximumValue)).trigger('change')
  }

  function decreaseItemQuantity() {
    const { $input } = cache

    let quantity = parseInt($input.val()) - 1
    let minimumValue = $input.prop('min') || -Infinity

    $input.val(Math.max(quantity, minimumValue)).trigger('change')
  }
}


/***/ })

}]);